
var LOCALE_BY_CURRENCY = {
  USD: 'en-US',
  CAD: 'en-CA',
  AUD: 'en-AU',
  NZD: 'en-NZ',
  GBP: 'en-GB',
  EUR: 'de-DE',
  CHF: 'de-CH',
  JPY: 'ja-JP',
  CNY: 'zh-CN',
  HKD: 'zh-HK',
  SGD: 'en-SG',
  THB: 'th-TH',
  MKD: 'mk-MK',
  MXN: 'es-MX',
  BRL: 'pt-BR',
  INR: 'en-IN',
  KRW: 'ko-KR',
  SEK: 'sv-SE',
  NOK: 'nb-NO',
  DKK: 'da-DK',
  PLN: 'pl-PL',
  CZK: 'cs-CZ',
  HUF: 'hu-HU',
  RON: 'ro-RO',
  BGN: 'bg-BG',
  ILS: 'he-IL',
  AED: 'ar-AE',
  SAR: 'ar-SA',
  ZAR: 'en-ZA'
};

var CURRENCY_SYMBOL_WHEN_INTL_SHOWS_CODE = {
  MKD: 'ден',
  THB: '฿'
};

function normalizeCurrencyCode(currencyCode) {
  if (currencyCode == null || currencyCode === '') return 'USD';
  return String(currencyCode).trim().toUpperCase();
}

function localeForCurrencyFormatting(normalizedCode) {
  if (LOCALE_BY_CURRENCY[normalizedCode]) {
    return LOCALE_BY_CURRENCY[normalizedCode];
  }
  var pageLang = (document.documentElement.lang || '').trim();
  if (/^[a-z]{2}-[A-Z]{2}$/i.test(pageLang)) {
    return pageLang;
  }
  return 'en-US';
}

function formatPresentmentMoney(minorAmount, currencyCode) {
  try {
    var code = normalizeCurrencyCode(currencyCode);
    var locale = localeForCurrencyFormatting(code);
    var nf = new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: code,
      currencyDisplay: 'symbol',
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    });
    const amount = Number(minorAmount) / 100;
    var parts = nf.formatToParts(amount);
    var sym = CURRENCY_SYMBOL_WHEN_INTL_SHOWS_CODE[code];
    var i;
    for (i = 0; i < parts.length; i++) {
      if (parts[i].type === 'currency' && sym && parts[i].value.replace(/\s/g, '') === code) {
        parts[i] = { type: 'currency', value: sym };
        break;
      }
    }
    let formatted = parts.map(function(p) {
      return p.value;
    }).join('');
    formatted = formatted.replace(/\.00$/, '');
    return formatted;
  } catch (e) {
    return (Number(minorAmount) / 100).toFixed(2);
  }
}

function getActiveCurrencyCode() {
  var sc = window.Shopify && window.Shopify.currency;
  return normalizeCurrencyCode((sc && (sc.active || sc.iso_code)) || 'USD');
}

function getVisibleProductPriceText() {
  var priceElements = document.querySelectorAll('.product__price .money, .price .money, [data-price]');
  for (var i = 0; i < priceElements.length; i++) {
    var el = priceElements[i];
    if (el && el.offsetParent !== null) {
      var txt = (el.textContent || '').trim().replace(/\.00$/, '');
      if (txt) return txt;
    }
  }
  return null;
}

function getVisibleCompareAtPriceText() {
  var strikeEls = document.querySelectorAll(
    's .money, .product__price--strike .money, s[data-compare-price], [data-compare-price]'
  );
  for (var i = 0; i < strikeEls.length; i++) {
    var el = strikeEls[i];
    if (el && el.offsetParent !== null) {
      var txt = (el.textContent || '').trim().replace(/\.00$/, '');
      if (txt) return txt;
    }
  }
  return null;
}

function updateVariantOptionPrices(product) {
  if (!product || !product.variants) return;

  var currency = getActiveCurrencyCode();
  var labels = document.querySelectorAll('.bcpo-front-button-label');

  labels.forEach(function(label) {
    var optionText =
      (label.getAttribute('data-vo-option-text') || '').trim() ||
      (label.querySelector('span') ? label.querySelector('span').textContent.trim() : label.textContent.trim());

    if (!optionText) return;
    label.setAttribute('data-vo-option-text', optionText);

    var variant = product.variants.find(function(v) {
      return Array.isArray(v.options) && v.options.includes(optionText);
    });
    if (!variant) return;

    var wrapper = label.querySelector('[data-vo-wrapper="1"]');
    if (!wrapper) {
      wrapper = document.createElement('div');
      wrapper.setAttribute('data-vo-wrapper', '1');
      wrapper.style.display = 'flex';
      wrapper.style.justifyContent = 'space-between';
      wrapper.style.width = '100%';

      var textSpan = document.createElement('span');
      textSpan.textContent = optionText;

      var priceSpan = document.createElement('span');
      priceSpan.className = 'vo-price-display custom-price';

      label.innerHTML = '';
      wrapper.appendChild(textSpan);
      wrapper.appendChild(priceSpan);
      label.appendChild(wrapper);
    } else {
      var left = wrapper.querySelector('span');
      if (left) left.textContent = optionText;
    }

    var priceSpan = label.querySelector('.vo-price-display');
    if (!priceSpan) return;

    var onSale = variant.compare_at_price && (variant.compare_at_price > variant.price);
    if (onSale) {
      priceSpan.innerHTML = '';
      var strike = document.createElement('s');
      strike.className = 'product__price--strike';
      strike.textContent = formatPresentmentMoney(variant.compare_at_price, currency);
      priceSpan.appendChild(strike);
      priceSpan.appendChild(document.createTextNode(' '));
      var current = document.createElement('span');
      current.textContent = formatPresentmentMoney(variant.price, currency);
      priceSpan.appendChild(current);
    } else {
      priceSpan.textContent = formatPresentmentMoney(variant.price, currency);
    }
  });

  var selected = document.querySelector(
    '.bcpo-front-button-label.selected, input[type="radio"]:checked + .bcpo-front-button-label'
  );
  var currentPriceText = getVisibleProductPriceText();
  if (selected) {
    var selectedPrice = selected.querySelector('.vo-price-display');
    if (!selectedPrice) return;

    var selectedOptionText =
      (selected.getAttribute('data-vo-option-text') || '').trim() ||
      (selected.querySelector('span') ? selected.querySelector('span').textContent.trim() : selected.textContent.trim());

    var selectedVariant = product.variants.find(function(v) {
      return Array.isArray(v.options) && v.options.includes(selectedOptionText);
    });

    var isOnSale = selectedVariant && selectedVariant.compare_at_price && (selectedVariant.compare_at_price > selectedVariant.price);
    var compareText = getVisibleCompareAtPriceText();

    if (isOnSale) {
      selectedPrice.innerHTML = '';
      var strike = document.createElement('s');
      strike.className = 'product__price--strike';
      strike.textContent = compareText || formatPresentmentMoney(selectedVariant.compare_at_price, currency);
      selectedPrice.appendChild(strike);
      selectedPrice.appendChild(document.createTextNode(' '));
      var current = document.createElement('span');
      current.textContent = currentPriceText || formatPresentmentMoney(selectedVariant.price, currency);
      selectedPrice.appendChild(current);
    } else if (currentPriceText) {
      selectedPrice.textContent = currentPriceText;
    }
  }
}

document.addEventListener('DOMContentLoaded', function() {
  setTimeout(function() {
    fetch(window.location.pathname + '.js')
      .then(response => response.json())
      .then(product => {
        updateVariantOptionPrices(product);

        var schedule = (function() {
          var t = null;
          return function() {
            if (t) clearTimeout(t);
            t = setTimeout(function() {
              updateVariantOptionPrices(product);
            }, 200);
          };
        })();

        document.addEventListener('click', function(e) {
          var el = e.target && e.target.closest ? e.target.closest('#bcpo .bcpo-front-button-label') : null;
          if (el) schedule();
        }, true);

        document.addEventListener('change', function(e) {
          var t = e.target;
          if (!t) return;
          if (t.closest && t.closest('#bcpo') && (t.type === 'radio' || t.tagName === 'SELECT')) {
            schedule();
          }
        }, true);

        if (window.MutationObserver) {
          var mo = new MutationObserver(function() {
            schedule();
          });
          mo.observe(document.body, { childList: true, subtree: true });
        }
      });
  }, 2000);
});
